import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 41.29 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M39.68 8.39H5.52l5.66-5.63A1.611 1.611 0 1 0 8.9.48L.47 8.86c-.63.63-.63 1.65 0 2.28l8.43 8.39a1.611 1.611 0 1 0 2.28-2.28l-5.66-5.63h34.16a1.609 1.609 0 1 0 0-3.22Z" })
});
export default SvgArrowBack;
